var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowRaiseCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#E31837",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23H9.5C8.67275 23 8 22.3273 8 21.5V10.25C8 9.42275 8.67275 8.75 9.5 8.75H24.5C25.3272 8.75 26 9.42275 26 10.25V21.5C26 22.3273 25.3272 23 24.5 23ZM9.5 9.5C9.08637 9.5 8.75 9.83638 8.75 10.25V21.5C8.75 21.9136 9.08637 22.25 9.5 22.25H24.5C24.9136 22.25 25.25 21.9136 25.25 21.5V10.25C25.25 9.83638 24.9136 9.5 24.5 9.5H9.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 25.25H11.75C11.543 25.25 11.375 25.082 11.375 24.875C11.375 24.668 11.543 24.5 11.75 24.5H22.25C22.457 24.5 22.625 24.668 22.625 24.875C22.625 25.082 22.457 25.25 22.25 25.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6325 25.25C19.6298 25.25 19.6276 25.25 19.625 25.25H14.375C14.2546 25.25 14.1413 25.1923 14.0708 25.094C14.0003 24.9961 13.9812 24.8705 14.0191 24.7561L14.7691 22.5061C14.8205 22.3531 14.9633 22.25 15.125 22.25H18.875C19.0366 22.25 19.1795 22.3531 19.2308 22.5065L19.9583 24.6894C19.9895 24.7441 20.0075 24.8075 20.0075 24.875C20.0075 25.082 19.8395 25.25 19.6325 25.25ZM14.8951 24.5H19.1048L18.605 23H15.3953L14.8951 24.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20H9.5V10.25H24.5V20ZM10.25 19.25H23.75V11H10.25V19.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21.875C17.4142 21.875 17.75 21.5392 17.75 21.125C17.75 20.7108 17.4142 20.375 17 20.375C16.5858 20.375 16.25 20.7108 16.25 21.125C16.25 21.5392 16.5858 21.875 17 21.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowRaiseCom);
export default __webpack_public_path__ + "static/media/how_raise_com.6d5e964f89c097c91c9325d787b2438f.svg";
export { ForwardRef as ReactComponent };